/* eslint-disable no-unused-vars */

<template>
  <div class="app-shell">
    <transition name="page-fade" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
    <AikenChatWidget v-if="showChatWidget" />
  </div>
</template>

<script>
const AikenChatWidget = () =>
  import(/* webpackChunkName: "AikenChatWidget" */ "@/components/AikenChatWidget.vue");

// Public / pre-login screens where the assistant has nothing to work with.
const CHAT_HIDDEN_ROUTES = [
  "Login",
  "Register",
  "AikenSuperAdminLogin",
  "LinkExpiry",
  "ForgotPassword",
  "ResetPassword",
  "User_login",
  "404_Error",
];

export default {
  components: { AikenChatWidget },
  computed: {
    showChatWidget() {
      return !CHAT_HIDDEN_ROUTES.includes(this.$route.name);
    },
  },
  mounted() {
    const styleMapping = [
      { storageKey: "btnText", cssVar: "--headBtn" },
      { storageKey: "btnbg", cssVar: "--btnBackgrnd" },
      { storageKey: "bgcolor", cssVar: "--colDefault" },
      { storageKey: "cardBg", cssVar: "--colCardBg" },
      { storageKey: "cardText", cssVar: "--colCardText" },
      { storageKey: "tableText", cssVar: "--colTableText" },
      { storageKey: "downloadText", sourceKey: "openedRowText", cssVar: "--colOpenedRowText" },
      { storageKey: "oddRow", cssVar: "--colOddRow" },
      { storageKey: "evenRow", cssVar: "--colEvenRow" },
      { storageKey: "card", cssVar: "--colEvenRow" },
      { storageKey: "SearchBox", cssVar: "--colSearchBox" },
      { storageKey: "BgGrayDark", cssVar: "--colBgGrayDark" },
      { storageKey: "fontSize", cssVar: "--CurrentFontSize" },
    ];

    styleMapping.forEach(({ storageKey, sourceKey, cssVar }) => {
      const keyToRead = sourceKey || storageKey;
      const keyExists = localStorage.getItem(storageKey);
      const value = localStorage.getItem(keyToRead);

      if (keyExists && value) {
        document.body.style.setProperty(cssVar, value);
      }
    });

    if (localStorage.getItem("tooltipTransform")) {
      document.body.style.setProperty(
        "--tooltipTransformY",
        localStorage.getItem("tooltipTransform") === "true" ? "-40px" : "0px"
      );
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/_mixin.scss";
@import "@/assets/scss/_base.scss";
@import "@/assets/scss/_design-system.scss";

:root {
  /* CSS variables */
  //for light & dark themes
  --btnBackgrnd: white;
  --headBtn: #1f5799;
  --colDefault: rgb(20, 22, 38);
  --colPowderblue: powderblue;
  --colCardBg: rgb(28, 34, 58);
  --colCardText: black;
  --colTableText: white;
  --colOpenedRowText: green;
  --colOddRow: rgb(36, 42, 68);
  --colEvenRow: rgb(24, 28, 48);
  --colSearchBox: black;
  --colBgGrayDark: #bbb9c0;
  --cardColor: #575757;
  // ------------------------------------
  // --TestColor: #cbdecf;

  /* CSS variables */
  //for font sizes
  --CurrentFontSize: 14px;
  --tooltipTransformY: 0px;
  // --font16px: 16px;
  // --font18px: 18px;
}

/* Fix for auto actions edit dialog cancel button in light mode */
body:not([style*="--colTableText: white"]) .ar-list-dialog .el-dialog__footer .el-button:not(.el-button--primary),
body:not([style*="--colTableText: white"]) .edit-rule-dialog .el-dialog__footer .el-button:not(.el-button--primary) {
  color: #606266 !important;
  background-color: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
}
body:not([style*="--colTableText: white"]) .ar-list-dialog .el-dialog__footer .el-button:not(.el-button--primary):hover,
body:not([style*="--colTableText: white"]) .edit-rule-dialog .el-dialog__footer .el-button:not(.el-button--primary):hover {
  color: #409EFF !important;
  border-color: #c6e2ff !important;
  background-color: #ecf5ff !important;
}

.qr-account-dropdown-menu.el-dropdown-menu {
  min-width: 138px !important;
  width: max-content !important;
  max-width: 190px !important;
  padding: 4px 0 !important;
  border-radius: 4px !important;
}

.qr-account-dropdown-menu .el-dropdown-menu__item {
  display: flex !important;
  align-items: center !important;
  height: 32px !important;
  line-height: 32px !important;
  padding: 0 14px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  white-space: nowrap !important;
}

.qr-account-dropdown-menu .dropdown-username {
  height: 34px !important;
  line-height: 34px !important;
  font-size: 13px !important;
}

body[style*="--colTableText: white"] .qr-account-dropdown-menu.el-dropdown-menu {
  border-color: #2d3d56 !important;
  background: rgba(20, 28, 41, 0.98) !important;
}
</style>
